import versionData from '@/version.json';
import * as Sentry from "@sentry/react";
import upperFirst from "lodash/upperFirst";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import { getPartnerByHost } from "./appSettings/Partners";

const env = import.meta.env
const environment = env.VITE_ENVIRONMENT
const baseUrl = env.VITE_BASE_URL

if (environment !== "development") {
  // Edit env name to match BE
  const envBe = environment === 'production' ? 'prod' : environment
  const sentryEnvironment = upperFirst(envBe + (getPartnerByHost().deployment ?? ''))

  Sentry.init({
    dsn: "https://cef007fe617ab1fbd71484faebddfd48@sentry.docker01.cebia.cz/13",
    tunnel: (baseUrl ?? '') + "/tunnel",
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        beforeAddRecordingEvent: (event) => {
          // Do not capture fetch/xhr requests details, unless the response status code > 400
          if (
            event.data.tag === "performanceSpan" &&
            (event.data.payload.op === "resource.fetch" || event.data.payload.op === "resource.xhr") &&
            event.data.payload.data.statusCode < 400
          ) {
            if (event.data.payload.data.response)
              event.data.payload.data.response.body = null;

            if (event.data.payload.data.request)
              event.data.payload.data.request.body = null;
          }

          return event;
        },
        networkDetailAllowUrls: [window.location.origin],
        maskAllText: false,
        maskAllInputs: false,
      })
    ],

    // Change tracesSampleRate to 10 % for test and prep environments and 1 % for all other environments
    tracesSampleRate: environment === "test" || environment === "prep" ? 0.1 : 0.01,

    // Přidává sentry hlavičky pro dané requesty
    tracePropagationTargets: [
      // /^\//
    ],

    // Change replaysSessionSampleRate to 10 % for test and prep environments and 1 % for all other environments
    replaysSessionSampleRate: environment === "test" || environment === "prep" ? 0.1 : 0.01,
    replaysOnErrorSampleRate: 1.0,

    // Vypne reporty, ktere nepodporuje self-hosted Sentry
    sendClientReports: false,

    environment: sentryEnvironment,
    release: `CommonClientV2@${versionData.version}`,
  })

  console.debug('Sentry is initialized.', environment)
}
else {
  console.debug("Sentry is disabled in development mode")
}